import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICreateVideoListReqBody, IInitState } from "../interfaces";

const initialState = {
  loading: false,
  data: [],
  error: "",
};

const createVideoSlice = createSlice({
  name: "createVideo",
  initialState,
  reducers: {
    createVideoRequest(
      state: IInitState,
      action: PayloadAction<ICreateVideoListReqBody>
    ) {
      state.loading = true;
    },
    createVideoSuccess(
      state: IInitState,
      action: PayloadAction<any[]>
    ) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { createVideoRequest, createVideoSuccess } =
  createVideoSlice.actions;
export default createVideoSlice.reducer;
